import { Injectable } from '@angular/core'
import { GetPaginatedMaintenancesQuery, Maintenance } from '@generated/sammathnaur.graphql'
import { Observable, firstValueFrom, from, map } from 'rxjs'
import { MaintenancesService } from '../../core/api/maintenances/maintenances.service'
import type { Apollo } from 'apollo-angular'

@Injectable({
  providedIn: 'root',
})
export class FcMaintenanceSelectService extends MaintenancesService {

  public override async searchPage(): Promise<Apollo.QueryResult<GetPaginatedMaintenancesQuery>> {
    return firstValueFrom(this.searchPage$())
  }

  public searchPage$(): Observable<any> {
    return from(super.searchPage()).pipe(
      map((maintenanceSearchResult: any) => {
        const maintenances = this.getMaintenancesWithNames(maintenanceSearchResult)
        return {
          ...maintenanceSearchResult,
          data: {
            ...maintenanceSearchResult.data,
            maintenances: {
              ...maintenanceSearchResult.data?.maintenances,
              items: maintenances
            }
          }
        }
      })
    )
  }

  private getMaintenancesWithNames(maintenanceSearchResult: any): { maintenance: Maintenance, name: string } {
    return maintenanceSearchResult?.data?.maintenances?.items.map((maintenance: Maintenance) => {
      const name = `${maintenance?.number} - ${maintenance?.maintenanceType?.name} - ${maintenance?.segment?.name} - ${maintenance?.location?.name}`
      return { ...maintenance, name }
    })
  }
}
